import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { initializeApp } from "firebase/app";

export const firebaseConfig = {
    apiKey: "AIzaSyDnkZrrFQ0RGetM753Gp0b859k7Nmk8rq8",
    authDomain: "grayportal-42161.firebaseapp.com",
    projectId: "grayportal-42161",
    storageBucket: "grayportal-42161.appspot.com",
    messagingSenderId: "793680550561",
    appId: "1:793680550561:web:9067c8ef09752c41252ee0",
    measurementId: "G-LSM7TLRB5Y"
};
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
